import type { FC } from 'react';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { CardTimer } from '@/components/CardTimer/CardTimer';
import type { MatchTimerProps } from './MatchTimer.types';
import styles from './MatchTimer.module.scss';
export const MatchTimer: FC<MatchTimerProps> = ({
  matchClosed,
  time,
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const [isCompleted, setIsCompleted] = useState(matchClosed);
  const handleCompleteTimer = useCallback(() => {
    setIsCompleted(true);
  }, []);
  return <>
      {!isCompleted && <div className={cn(styles.root, className)}>
          <CardTimer size="large" date={time} onComplete={handleCompleteTimer} />
          <p className={styles.matchStatus}>{t('match_status.before_event_begins', 'Before the event begins')}</p>
        </div>}
    </>;
};